// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"594":"about","604":"company"}[chunkId] + "." + {"594":"ed0be28f","604":"87d1bab8"}[chunkId] + ".css";
};